import { lessThan16Years } from "../../../utils/formHelper";

export const EmployeeProfileFormConfig = {
  employeeStatusTypeGuid: {
    label: "Employee Status",
    perKey: "EmployeeStatus",
    defaultValue: null,
    rules: { required: "Employee Status is required!" }
  },
  internalEmployeeId: {
    label: "Internal Employee Id",
    perKey: "InternalEmployeeID",
    rules: {
      required: "Internal Employee Id is required!",
      maxLength: {
        value: 50,
        message: "Internal Employee Id cannot exceed 50 characters"
      }
    }
  },
  firstName: {
    label: "First Name",
    rules: { required: "First Name is required!" },
    perKey: "FirstName"
  },
  middleName: {
    label: "Middle Name",
    perKey: "MiddleName"
  },
  lastName: {
    label: "Last Name",
    rules: { required: "Last Name is required!" },
    perKey: "LastName"
  },
  jobTitle: {
    label: "Position/Job Title",
    perKey: "JobTitle"
  },
  department: {
    label: "Department",
    perKey: "Department"
  },
  cellPhone: {
    label: "Cell Phone",
    rules: {
      required: "Cell Phone is required!",
      pattern: {
        value: /^.{14}$/,
        message: "Cell Phone Number must be 10 digits"
      }
    },
    perKey: "CellPhone"
  },
  officePhone: {
    label: "Office Phone",
    perKey: "OfficePhone",
    rules: {
      pattern: {
        value: /^.{14}$/,
        message: "Office Phone Number must be 10 digits"
      }
    }
  },
  email: {
    label: "Email",
    rules: { required: "Email is required!" },
    perKey: "Email"
  },
  whatsApp: {
    label: "Whats App",
    perKey: "WhatsApp",
    rules: {
      pattern: {
        value: /^.{14}$/,
        message: "Whats App Number must be 10 digits"
      }
    }
  },
  last4ofSSN: {
    label: "Last 4 SSN Digits",
    rules: {
      required: "Last 4 of SSN is required!",
      pattern: {
        value: /^\d{4}$/,
        message: "Last 4 of SSN must be exactly 4 digits"
      }
    },
    perKey: "SSN"
  },
  ssn: {
    label: "SSN",
    rules: { required: "SSN is required!" },
    perKey: "SSN"
  },
  birthDate: {
    label: "Date of Birth",
    defaultValue: null,
    perKey: "BirthDate",
    rules: { validate: lessThan16Years }
  },
  sex: {
    label: "Sex",
    perKey: "Sex"
  },
  profilePictureFile: {
    label: "Profile Picture",
    perKey: "ProfilePicture",
    defaultValue: null,
    readKey: "profilePicture"
  },
  yearsOfExperience: {
    label: "Years of Experience",
    perKey: "YearsOfExperience"
  },
  isAppentice: {
    label: "Is Apprentice",
    perKey: "IsAppentice",
    defaultValue: false
  },
  ethnicityTypeId: {
    label: "Ethnicity",
    perKey: "Ethnicity",
    defaultValue: null
  },
  veteranStatusTypeId: {
    label: "Veteran Status",
    perKey: "VeteranStatus",
    defaultValue: null
  },
  raceTypeId: {
    label: "Race",
    perKey: "Race",
    defaultValue: null
  },
  educationLevelTypeId: {
    label: "Education Level",
    perKey: "EducationLevel",
    defaultValue: null
  },
  disabilityTypeId: {
    label: "Disability",
    perKey: "Disability",
    defaultValue: null
  },
  rapInfoId: {
    label: "Apprenticeships Program",
    perKey: "ApprenticeshipsProgram",
    defaultValue: null,
    rules: { required: "Apprenticeships Program is required!" }
  },
  dateApprenticeshipBegins: {
    label: "Date Apprenticeship Begins",
    defaultValue: null,
    perKey: "DateApprenticeshipBegins"
  },
  careerConnectionTypeId: {
    label: "Career Connection",
    perKey: "CareerConnection",
    defaultValue: null
  },
  anyCredit: {
    label: "Any credit for Previous On-the-job Learning Experience?",
    perKey: "AnyCredit",
    defaultValue: null
  },
  rti: {
    label: "RIL or Related Instruction, any Credit for Previous Instruction Experience?",
    perKey: "Rti",
    defaultValue: null
  },
  apprenticeStatusTypeId: {
    label: "Apprentice Status",
    perKey: "ApprenticeStatus",
    defaultValue: null
  },
  apprenticeshipRegNumber: {
    label: "Apprenticeship Number",
    perKey: "ApprenticeshipRegNumber"
  },
  address: {
    label: "Address",
    rules: { required: "Address is required!" },
    perKey: "Address"
  },
  address2: {
    label: "Address 2",
    perKey: "Address2"
  },
  state: {
    label: "State",
    rules: { required: "State is required!" },
    perKey: "State"
  },
  city: {
    label: "City",
    rules: { required: "City is required!" },
    perKey: "City"
  },
  zip: {
    label: "Zip",
    perKey: "Zip",
    rules: {
      required: "Zip is required!"
    }
  },
  mailingAddress: {
    label: "Mailing Address",
    perKey: "MailingAddress"
  },
  mailingState: {
    label: "Mailing State",
    perKey: "MailingState"
  },
  mailingCity: {
    label: "Mailing City",
    perKey: "MailingCity"
  },
  mailingZip: {
    label: "Mailing Zip",
    perKey: "MailingZip"
  },
  fringePaymentMethodType: {
    label: "Fringe Payment Method",
    perKey: "FringePaymentMethod",
    defaultValue: null
  },
  hourlyRateAmount: {
    label: "Hourly Rate Amount",
    perKey: "HourlyRateAmount",
    defaultValue: null
  },
  fringeRateAmount: {
    label: "Fringe Rate Amount",
    perKey: "FringeRateAmount",
    defaultValue: null
  },
  startDate: {
    label: "Start Date",
    defaultValue: null,
    perKey: "StartDate",
    rules: {
      validate: (value, formValues) => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter valid date";
        if (formValues.endDate && formValues.endDate < value) {
          return "Start Date should be less than End Date";
        }
      }
    }
  },
  endDate: {
    label: "End Date",
    defaultValue: null,
    perKey: "EndDate",
    rules: {
      validate: (value, formValues) => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter valid date";
        if (formValues.startDate && formValues.startDate > value) {
          return "End Date should be greater than Start Date";
        }
      }
    }
  },
  manager: {
    label: "Manager",
    perKey: "Manager",
    defaultValue: null
  },
  languageType: {
    label: "Language",
    perKey: "Language",
    defaultValue: null
  },
  notificationType: {
    label: "Notification",
    perKey: "Notification",
    defaultValue: null
  },
  employmentTermTypeId: {
    label: "Employment Term",
    perKey: "EmploymentTerm",
    defaultValue: null
  },
  employmentStatus: {
    label: "Employment Status",
    perKey: "EmploymentStatus",
    defaultValue: null
  },
  employeeTypeId: {
    label: "Employee Type",
    perKey: "EmployeeTypeId",
    rules: { required: "Please enter the Employee Type" },
    //defaultValue: "Apprentice"
    default: null
  },
  apprenticeProspectStatusTypeId: {
    label: "Apprentice Application Status",
    perKey: "ApprenticeProspectStatusTypeId",
    defaultValue: null
  },
  healthInsuranceId: {
    label: "Health Insurance",
    perKey: "HealthInsuranceId",
    defaultValue: null
  },
  retirementPensionId: {
    label: "Retirement/Pension",
    perKey: "RetirementPensionId",
    defaultValue: null
  },
  isUnion: {
    label: "Is Union Employee?",
    perKey: "IsUnion",
    defaultValue: false
  }
};

export const EmployeeDocumentsFormConfig = {
  documentName: {
    label: "Document Name",
    perKey: "documentName",
    rules: {
      required: "Document Name is required!",
      maxLength: {
        value: 250,
        message: "Document Name cannot exceed 250 characters"
      }
    }
  },
  employeeDocumentTypeId: {
    label: "Employee Document Type",
    perKey: "employeeDocumentTypeId",
    rules: {
      required: "Document Type is required!"
    }
  },
  documentMediaModel: {
    label: "Document Upload",
    perKey: "documentMediaModel",
    rules: {
      required: "Document is required!"
    }
  }
};

export const EmployeeNotesFormConfing = {
  noteTitle: {
    name: "noteTitle",
    label: "Title",
    perKey: "NoteTitle"
  },
  notes: {
    name: "notes",
    label: "Note",
    perKey: "Notes"
  },
  isPrivate: {
    name: "isPrivate",
    label: "Is Private",
    perKey: "IsPrivate",
    defaultValue: false
  }
};

export const EmployeeSocialMediaFormConfig = {
  socialMediaType: {
    name: "socialMediaType",
    label: "Social Media Type",
    size: "4",
    perKey: "SelectSociaMediaType"
  },
  handle: {
    name: "handle",
    label: "Handle",
    size: "4",
    perKey: "Handle"
  }
};

export const MappingForETA671Form = {
  ethnicity: {
    chkHispanicOrLatino: "Hispanic or Latino",
    chkNotHispanicOrLatino: "Non Hispanic or Latino",
    chkEthnicityParticipantDidNotSelfIdentify: "Participant Did Not Self Identify"
  },
  sex: {
    chkMale: "male",
    chkFemale: "female",
    chkSexParticipantDidNotSelfIdentify: "notIdentify"
  },
  race: {
    chkAmericanIndianOrAlaskaNative: "American Indian or Alaska Native",
    chkAsian: "Asian",
    chkBlackOrAfricanAmerican: "Black or African-American",
    chkNativeHawaiianOrOtherPacificIslander: "Native Hawaiian or Other Pacific Islander",
    chkWhite: "White",
    chkRaceParticipantDidNotSelfIdentify: "Do Not wish to answer"
  },
  veteranStatus: {
    chkNonVeteran: "Non-Veteran",
    chkVeteran: "Veteran",
    chkNonVeteranOtherEligibleIndividual: "Non-Veteran or Other Eligible Individual",
    chkVeteranEligible: "Veteran Eligible",
    chkVeteranStatusParticipantDidNotSelfIdentify: "Participant Did Not Self Identify"
  },
  educationLevel: {
    chkNotHighSchoolGraduate: "Non High School Graduate ",
    chkHighSchoolGraduate: "High School Graduate",
    chkSomeCollegeOrAssociateDegree: "Some College or Associates Degree",
    chkBachelorsDegree: "Bachelors Degree",
    chkMastersDegree: "Master Degree",
    chkDoctorateOrProfessionalDegree: "Doctorate or Professional Degree"
  },
  apprenticeEmploymentStatus: {
    chkNewEmployee: "New",
    chkCurrentEmployee: "Current"
  },
  preApprenticeShipCompletion: {
    rdPreApprenticeShipCompletion: "No"
  },
  interimCredentialsOffered: {
    rdInterimCredentialsOffered: "No_2"
  },
  occupationType: {
    chkTimeBased: "Time-based",
    chkCompetencyBased: "Competency",
    chkHybrid: "Hybrid"
  },
  isWagePaid: {
    chkIsWagePaidYes: "Y",
    chkIsWagePaidNo: "Y"
  },
  relatedInstructionHours: {
    chkDuringWorkHours: "duringworkhours",
    chkNotDuringWorkHours: "notduringworkhours",
    chkBothDuringAndNotDuringWorkHours: "bothduringandnotduringworkhours"
  },
  wageRate: {
    chkJourneyWorkerPercentage: "% of Journeyworker wage",
    chkAmountOfWage: "$ amount of wage",
    chkBothPercentageAndAmountOfWage: "Both % and $ amount of wage"
  }
};
